import React from 'react';

// Internal Import
import { AppBarComponent } from '../components/appbar';
import { FooterComponent } from '../components/footer';

// External Import
import { common } from "@mui/material/colors";
import { useNavigate, useParams } from 'react-router-dom';


import {
    Box,
    Grid,
    Stack,
    Button,
    Typography,
} from '@mui/material';




export interface PromotionsProps { }
export const PromotionsScreen: React.FC<PromotionsProps> = () => {

    let navigate = useNavigate();

    let { id } = useParams();


    return (
        <Stack>
            <AppBarComponent />

            {/* // Footer // */}
            <FooterComponent />

        </Stack>
    )
};